/*==================================================
    program name    : 網路狀態監聽處理
    author          : Samma
    last update     : 2020-05-07
    use description : 
==================================================*/
import store from '@/store';

export default {
  //註冊偵測網路狀態事件
  registerNetActiveEvent: function () {
    window.addEventListener('online', this.networkChange);
    window.addEventListener('offline', this.networkChange);
  },
  //處理網路狀態改變
  networkChange: function () {
    if (navigator.onLine) {
      store.commit('netOnline');
    } else {
      store.commit('netOffline');
    }
  },
};
